"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.invertIconVars = exports.default = void 0;
var _reactJss = require("react-jss");
var _initVars = _interopRequireDefault(require("../../../utils/vars/initVars"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * @copyright
 * Copyright (c) 2023 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */

var invertIconVars = exports.invertIconVars = (0, _initVars.default)({
  applied: ["background", "height", "width"]
});
var invertIconStyles = function invertIconStyles(theme) {
  return {
    variables: invertIconVars.styles,
    root: {
      boxSizing: "content-box",
      display: "block",
      padding: theme.spacing.base * 2,
      borderRadius: "50%"
    }
  };
};
var invertIconUseStyles = (0, _reactJss.createUseStyles)(invertIconStyles, {
  name: "Interstitial"
});
var _default = exports.default = invertIconUseStyles;